// extracted by mini-css-extract-plugin
export default {"container":"B_-z"};